export default __webpack_public_path__ + "static/media/media-kit-en.f778b061.svg";